module.exports = __webpack_public_path__ + "img/login-img-3.84947f67.svg";